export var EscalationStatus;
(function (EscalationStatus) {
    EscalationStatus["PENDING"] = "pending";
    EscalationStatus["COMPLETE"] = "complete";
    EscalationStatus["CANCELLED"] = "cancelled";
})(EscalationStatus || (EscalationStatus = {}));
export var EscalationSchedule;
(function (EscalationSchedule) {
    EscalationSchedule["READY"] = "ready";
    EscalationSchedule["SOON"] = "soon";
})(EscalationSchedule || (EscalationSchedule = {}));
export var IEscalationOutcome;
(function (IEscalationOutcome) {
    IEscalationOutcome["NO_RESPONSE"] = "NO_RESPONSE";
    IEscalationOutcome["LEFT_MESSAGE"] = "LEFT_MESSAGE";
    IEscalationOutcome["SPOKE_TO_CUSTOMER"] = "SPOKE_TO_CUSTOMER";
    IEscalationOutcome["SET_EXPECTED_PAYMENT_DATE"] = "SET_EXPECTED_PAYMENT_DATE";
})(IEscalationOutcome || (IEscalationOutcome = {}));
export const EscalationOutcomeLabels = {
    [IEscalationOutcome.NO_RESPONSE]: `No response`,
    [IEscalationOutcome.LEFT_MESSAGE]: `Left a message`,
    [IEscalationOutcome.SPOKE_TO_CUSTOMER]: `Spoke to customer`,
    [IEscalationOutcome.SET_EXPECTED_PAYMENT_DATE]: `Set expected payment date`,
};
//# sourceMappingURL=escalation.js.map